<template>
  <layout>
    <section id="explain" class="explain">
      <b-container>
        <div class="intro">
          <h2>{{ $t('pages.partner.how_to.title') }}</h2>
          <p>{{ $t('pages.partner.how_to.text') }}</p>
        </div>
      </b-container>
      <image-block
        v-for="explain in explainProcess"
        :key="explain.title"
        :image-url="explain.imageUrl"
        :image-on-right="explain.imageOnRight"
        :title="explain.title"
        :text="explain.text"
      />
      <e-jumbotron :data="jumbotron">
        <b-button variant="primary" @click="openModal(modalName('new'))">
          {{ jumbotron.btnText }}
        </b-button>
      </e-jumbotron>
    </section>
    <e-modal :event-id="modalName('new')" :title="$t('pages.prescriber.new')">
      <ajax-new
        :close-modal="true"
        :config="{ headers: { 'Content-Language': $translation.getLocale() } }"
        :ref-modal="modalName('new')"
        :load-on-mount="false"
        :is-disabled="isNotAccepted"
        name="prescriber"
        uri="api/public/prescriber"
      >
        <div slot="beforeSubmit">
          <b-form-checkbox
            id="checkbox"
            v-model="terms"
            :required="true"
            @change="accept"
          >
            {{ $t('accept_terms_and_uses_prescriber_1') }}
            <a :href="documentPath" target="_blank">{{ $t('accept_terms_and_uses_prescriber_2') }}</a>
          </b-form-checkbox>
        </div>
      </ajax-new>
    </e-modal>
  </layout>
</template>

<script>
  import AjaxNew from '@triotech/vue-core/src/components/ajax/AjaxNew';
  import Layout from '@/views/Default/Layout';
  import ImageBlock from '@/components/ImageBlock';
  import EJumbotron from '@/components/EJumbotron';
  import EModal from '@/components/EModal';

  export default {
    name: 'Partner',
    components: {
      AjaxNew,
      ImageBlock,
      EJumbotron,
      EModal,
      Layout,
    },
    data() {
      return {
        document: null,
        explainProcess: [{
          imageUrl: '../../../static/img/tmp.jpg',
          imageOnRight: false,
          title: this.$t('pages.partner.create.title'),
          text: this.$t('pages.partner.create.text'),
        }, {
          imageUrl: '../../../static/img/tmp.jpg',
          imageOnRight: true,
          text: this.$t('pages.partner.comunicate.text'),
        }, {
          imageUrl: '../../../static/img/tmp.jpg',
          imageOnRight: false,
          text: this.$t('pages.partner.share.text'),
        }, {
          imageUrl: '../../../static/img/tmp.jpg',
          imageOnRight: true,
          text: this.$t('pages.partner.how.text'),
        }, {
          imageUrl: '../../../static/img/tmp.jpg',
          imageOnRight: false,
          text: this.$t('pages.partner.why_1.text'),
        }, {
          imageUrl: '../../../static/img/tmp.jpg',
          imageOnRight: true,
          text: this.$t('pages.partner.why_2.text'),
        }, {
          imageUrl: '../../../static/img/tmp.jpg',
          imageOnRight: false,
          text: this.$t('pages.partner.end.text'),
        }],
        jumbotron: {
          bg: '../../../static/img/tmp.jpg',
          title: this.$t('pages.partner.jumbotron.title'),
          btnText: this.$t('actions.start'),
        },
        isNotAccepted: true,
        terms: false,
      };
    },
    computed: {
      documentPath() {
        if (this.document) {
          return this.$ajax.getUploadsUri(this.document.file_url);
        }

        return null;
      },
    },
    mounted() {
      this.getPartnerContact();
    },
    methods: {
      accept() {
        this.isNotAccepted = !this.isNotAccepted;

        return this.isNotAccepted;
      },
      modalName(action) {
        return `presciber-${action}`;
      },
      openModal(id, data = null) {
        this.$bus.$emit(`t-event.t-modal.${id}.open`, data);
      },
      async getPartnerContact() {
        this.document = await this.$ajax.get(`api/public/document_front/${this.$translation.getLocale()}`);
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';
</style>



// WEBPACK FOOTER //
// src/views/Default/Partner.vue